import { TextAreaAppearance as FluentTextAreaAppearance, TextAreaAutocomplete as FluentTextAreaAutocomplete, TextAreaResize as FluentTextAreaResize, TextAreaSize as FluentTextAreaSize, TextAreaAppearancesForDisplayShadow as FluentTextAreaAppearancesForDisplayShadow } from "@fluentui/web-components";
/** Appearance values for {@link TextArea}. */
export const TextareaAppearances = { ...FluentTextAreaAppearance };
/** Autocomplete values for {@link TextArea}. */
export const TextareaAutocompletes = { ...FluentTextAreaAutocomplete };
/** Resize values for {@link TextArea}. */
export const TextareaResizes = { ...FluentTextAreaResize };
/** Size values for {@link TextArea}. */
export const TextareaSizes = { ...FluentTextAreaSize };
/** Appearance values that support display shadows for {@link TextArea}. */
export const TextareaAppearancesForDisplayShadows = [
    ...FluentTextAreaAppearancesForDisplayShadow
];
//# sourceMappingURL=textarea.options.js.map